<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <div class="photos">
    <aside>
      If you have photos from VIZBI {{ year }} to share, upload them to
      <a href="https://www.flickr.com/signin">Flickr</a> &amp; tag with &lsquo;<a
        :href="`https://www.flickr.com/search/?tags=vizbi&sort=date-taken-asc&view_all=1&min_taken_date=${minDate}&max_taken_date=${maxDate}`"
      >vizbi</a
      >&rsquo;. Photo date must be within {{ dateText }}.
    </aside>
    <div v-if="isLoading" class="loading">
      <div class="spinner" />
    </div>
    <div v-else class="grid">
      <Photo
        v-for="photo in photos"
        :key="photo.id"
        :photo="photo"
        :year="year"
        @highlight="updateHighlightedPhoto" />
    </div>
    <PhotoHighlightState :image="highlightedImage" @hide="updateHighlightedPhoto" />
  </div>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import Photo from "@/components/Photo";
import PhotoHighlightState from "@/components/PhotoHighlightState";
import {fetchFlickrPhotos} from "@/composables/useFlickrSearch";

const props = defineProps({
  year: {type: String, required: true},
  minDate: {type: Number, required: true},
  maxDate: {type: Number, required: true},
  dateText: {type: String, required: true}
});

const photos = ref([]);
const byID = reactive({});
const highlightedImage = ref(null);
const isLoading = ref(true);

const updateHighlightedPhoto = (photo) => {
  highlightedImage.value = photo ? byID[photo.id] : null;
};

onMounted(async () => {
  const data = await fetchFlickrPhotos(props.minDate, props.maxDate);
  if (data?.byYear[props.year]) photos.value = data.byYear[props.year];
  Object.assign(byID, data?.byID || {});
  isLoading.value = false;
});
</script>

<style scoped>
.photos {
  width: 100%;
}
aside {
  font-weight: 200;
  font-size: 0.9rem;
  margin-top: 8px;
  margin-bottom: 12px;
}
.loading {
  width: 100%;
  min-height: 40vh;
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #ddd;
  border-top-color: #888;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {transform: rotate(360deg);}
}
.grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
